import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=3722e870&"
import script from "./LoginPage.vue?vue&type=script&lang=js&"
export * from "./LoginPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports